module.exports = __webpack_public_path__ + "static/media/events-bg.4417df36.png";